<template>
  <label class="flex flex-col gap-1" :data-testid="testId">
    <span class="text-[11px] uppercase tracking-wider text-neutral50">Agrupar por</span>
    <select
      class="rounded-md border border-lightGray30 bg-white px-2 py-1 text-[13px] text-textPrimary disabled:cursor-not-allowed disabled:opacity-50"
      :value="modelValue"
      :disabled="disabled"
      :title="disabled ? 'A Tabela é plana, ordenada pelo prazo' : undefined"
      :data-testid="`${testId}-select`"
      @change="onChange"
    >
      <option v-for="option in PRIORITY_GROUP_BY_OPTIONS" :key="option.value" :value="option.value">
        {{ option.label }}
      </option>
    </select>
  </label>
</template>

<script setup lang="ts">
import { PRIORITY_GROUP_BY_OPTIONS } from '../composables/usePriorityGrouping'
import type { PriorityGroupBy } from '../composables/usePriorityGrouping'

withDefaults(
  defineProps<{
    modelValue: PriorityGroupBy
    disabled?: boolean
    testId?: string
  }>(),
  { disabled: false, testId: 'priority-payments-group-by' }
)

const emit = defineEmits<{ 'update:modelValue': [value: PriorityGroupBy] }>()

function onChange(event: Event): void {
  emit('update:modelValue', (event.target as HTMLSelectElement).value as PriorityGroupBy)
}
</script>
